import { type ConnatixPlayerApi } from '@/connatix/connatixTypes'
import { recordAndTrackDifference } from '@/utils/tracking/videoTiming'

export const CNX_TIMING_EVENTS = {
    CNX_SCRIPTS_LOAD_START: 'cnx-scripts-load-start',
    CNX_READY: 'cnx-ready',
    CNX_PLAYING_CONTENT_OR_AD: 'cnx-playing-content-or-ad',
}

export function handleTiming(playerApi: ConnatixPlayerApi) {
    playerApi.on('play', () => {
        recordAndTrackDifference(
            CNX_TIMING_EVENTS.CNX_PLAYING_CONTENT_OR_AD,
            CNX_TIMING_EVENTS.CNX_READY,
        )
    })
    playerApi.on('adImpression', () => {
        recordAndTrackDifference(
            CNX_TIMING_EVENTS.CNX_PLAYING_CONTENT_OR_AD,
            CNX_TIMING_EVENTS.CNX_READY,
        )
    })
}
